<div class="m-1" [class.invalid]="invalid()">
    @if (AdaaHelper.isDefinedAndNotEmpty(label())) {
        <label [for]="effectiveControlId()" class="d-flex justify-content-center form-label">
            {{ label() }}
            @if (isRequired()) {
                <span class="form-required text-danger fw-bolder">*</span>
            }
        </label>
    }
    @if (info()) {
        <p class="d-flex justify-content-center fst-italic text">{{ info() }}</p>
    }

    <div class="textarea-container">
        <textarea
            #textarea
            [id]="effectiveControlId()"
            cols="20"
            [attr.rows]="rows()"
            class="form-control shadow-sm"
            [class.is-invalid]="invalid()"
            [class.is-correct]="correct === true"
            [class.is-incorrect]="correct === false"
            style="resize: none"
            [placeholder]="placeholder()"
            [formControl]="inputControl"
            (ngModelChange)="valueChanged($event)"
        >
        </textarea>
        @if (pageMode() !== PageMode.view) {
            <button
                class="btn"
                [class.btn-blue]="correct !== true && correct !== false"
                [class.success]="correct === true"
                [class.btn-danger]="correct === false"
                (click)="validateFormula()"
                [disabled]="!output || !output.length"
            >
                @if (correct) {
                    <span>{{ "kpi.valid" | translate }}</span>
                } @else {
                    <span>{{ ("kpi.validate_formula" | translate) + "/" + ("metrics.metrics" | translate) }}</span>
                }
            </button>
        }
    </div>
</div>
